import { useAdvanceBlogContent, useAdvanceSubtopicBlogContent } from "../../hooks/utils";
import AdvanceOption from "./AdvanceOption";

function AdvancedOptionParent() {
  const { isLoading, content } = useAdvanceBlogContent();
  const { loading, setLoading, advanceSubtopicData, projectId, title, items, setItems, isDisable, setIsDisable, generatedItems, titleAndMetaDescription, setGeneratedItems } =
    useAdvanceSubtopicBlogContent();
  return (
    <div>
      <AdvanceOption
        isLoading={isLoading}
        content={content}
        loading={loading}
        setLoading={setLoading}
        advanceSubtopicData={advanceSubtopicData}
        projectId={projectId}
        title={title}
        items={items}
        setItems={setItems}
        isDisable={isDisable}
        setIsDisable={setIsDisable}
        generatedItems={generatedItems}
        titleAndMetaDescription={titleAndMetaDescription}
        setGeneratedItems={setGeneratedItems}
      />
    </div>
  );
}

export default AdvancedOptionParent;
